import SureModal from './components/SureModal.css';
import SureModalContent from './components/SureModalContent/SureModalContent.css';
export default {
    SureModal,
    SureModalContent
};
